export default __webpack_public_path__ + "static/media/result4.df75268f.png";